module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "preface",
    attrs: {
      "id": "col"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("Other Books by Roger Ebert")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br'), _vm._v("An Illini Century: One Hundred Years of Campus Life")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("A Kiss Is Still a Kiss")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Two Weeks in the Midday Sun: A Cannes Notebook")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Behind the Phantom’s Mask")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Roger Ebert’s Little Movie Glossary")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Roger Ebert’s Movie Home Companion (annually 1986–1993)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Roger Ebert’s Video Companion (annually 1994–1998)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Roger Ebert’s Movie Yearbook (annually 1999–2007, 2009–2012)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Questions for the Movie Answer Man")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Roger Ebert’s Book of Film: From Tolstoy to Tarantino,\nthe Finest Writing from a Century of Film")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Ebert’s Bigger Little Movie Glossary")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I Hated, Hated, Hated This Movie")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Great Movies")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Great Movies II")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Your Movie Sucks")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Roger Ebert’s Four-Star Reviews 1967–2007")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Awake in the Dark: The Best of Roger Ebert")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Scorsese by Ebert")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Life Itself: A Memoir")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("A Horrible Experience of Unbearable Length")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br'), _c('strong', [_vm._v("With Daniel Curley")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Perfect London Walk")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br'), _c('strong', [_vm._v("With Gene Siskel")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Future of the Movies: Interviews with Martin Scorsese,\nSteven Spielberg, and George Lucas")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br'), _c('strong', [_vm._v("DVD Commentary Tracks")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Beyond the Valley of the Dolls")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Citizen Kane")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Dark City")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Casablanca")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Crumb")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Floating Weeds")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br'), _c('strong', [_vm._v("Other Ebert’s Essentials")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("33 Movies to Restore Your Faith in Humanity")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("25 Great French Films")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("27 Movies from the Dark Side")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7452980","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792175_epub_col_r1.vue
// module id = 60
// module chunks = 0